import React, { createContext, useState, ReactNode, useMemo } from "react";

interface UserFromCognito {
  username: string;
  [key: string]: any;
}

interface AuthState {
  accessToken: string | null;
  userFromCognito: UserFromCognito | null;
  user?: string | null;
  clientId?: string | null;
}

interface AuthContextType {
  auth: AuthState;
  setAuth: React.Dispatch<React.SetStateAction<AuthState>>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [auth, setAuth] = useState<AuthState>({
    accessToken: null,
    userFromCognito: null,
    clientId: null,
  });

  const contextValue = useMemo(() => ({ auth, setAuth }), [auth, setAuth]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
